import { Grid, Typography } from "@mui/material";
import { Colors } from "Components/Layout/Themes/Colors";
import { PrimaryPaper } from "Components/Shared/PrimaryPaper";
import { useIsUserInMooneLite } from "Hooks/useIsUserInMooneLite";
import { useIsUserPreApproved } from "Hooks/useIsUserPreApproved";
import { useIsUserVerified } from "Hooks/useIsUserVerified";
import { Resources, useResource } from "Translations/Resources";

const COMPONENT_RESOURCES = Resources.Components.LimitedAccountPopup;

export const LimitedAccountPopup = () => {
  const { t } = useResource();
  const { isUserVerified, isLoading } = useIsUserVerified();
  const { isUserInMooneLite } = useIsUserInMooneLite();
  const { isPreApproved, isLoading: isPreApprovedLoading } =
    useIsUserPreApproved();

  if (
    isLoading ||
    isPreApprovedLoading ||
    isUserVerified ||
    isUserInMooneLite ||
    isPreApproved
  ) {
    return null;
  }

  return (
    <div>
      <PrimaryPaper>
        <Typography
          color={Colors.Red}
          align="left"
          fontWeight={600}
          marginBottom={3}
        >
          {t(COMPONENT_RESOURCES.Title)}
        </Typography>
        <Grid container spacing={4}>
          <Grid size={{ xs: 12 }}>
            <Typography align="left" color={Colors.Red}>
              {t(COMPONENT_RESOURCES.Message)}
            </Typography>
          </Grid>
        </Grid>
      </PrimaryPaper>
    </div>
  );
};
